<template>
  <div>
    <h5>Trocar senha</h5>
    <p class="login-description text-muted mt-2 mb-5">
      Para alterar sua senha, você precisa informar o email de login que recebeu
      o token de confirmação.
    </p>

    <form @submit.prevent="submit()">
      <b-form-group label="E-mail:">
        <b-form-input
          v-model="form.email"
          placeholder="E-mail"
          :state="validateState('email')"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.form.email.required"
            >E-mail é um campo obrigatório.</span
          >
          <span v-if="!$v.form.email.email">E-mail inválido</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Nova Senha:">
        <b-input-group class="login-pass">
          <b-form-input
            v-model="form.password"
            :state="validateState('password')"
            placeholder="Nova Senha"
            type="password"
            class="input-pass"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              class="button-show-pass"
              :state="validateState('password')"
              @click="show_pass = !show_pass"
            >
              <font-awesome-icon icon="eye" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :state="validateState('password')">
          <span v-if="!$v.form.password.minLength">Senha é obrigatório.</span>
        </b-form-invalid-feedback>
        <b-form-text>
          <span v-if="show_pass">{{ form.password }}</span>
          &nbsp;</b-form-text
        >
      </b-form-group>

      <b-form-group label="Confirmar Nova Senha:">
        <b-input-group class="login-pass">
          <b-form-input
            v-model="form.password_confirmation"
            :state="validateState('password_confirmation')"
            placeholder="Confirmar Senha"
            type="password"
            class="input-pass"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              class="button-show-pass"
              :state="validateState('password_confirmation')"
              @click="show_pass = !show_pass"
            >
              <font-awesome-icon icon="eye" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback
          :state="validateState('password_confirmation')"
        >
          <span v-if="!$v.form.password_confirmation.sameAsPassword"
            >Confirme a senha corretamente.</span
          >
        </b-form-invalid-feedback>
        <b-form-text>
          <span v-if="show_pass">{{ form.password_confirmation }}</span>
          &nbsp;</b-form-text
        >
      </b-form-group>

      <b-row class="login-actions">
        <b-col cols="auto" class="mr-auto"
          ><router-link :to="{ name: 'login' }">Voltar </router-link></b-col
        >
        <b-col cols="auto"
          ><button class="btn login-button">
            Enviar <span class="material-icons"> arrow_right_alt </span>
          </button></b-col
        >
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email, sameAs } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      email: "",
      password: "",
      password_confirmation: "",
      token: "",
    },
    show_pass: false,
    error_message: "",
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      password_confirmation: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {},
  methods: {
    ...mapActions("auth", ["ActionResetPassword"]),
    async submit() {
      this.error_message = "";
      try {
        this.$v.$touch();
        if (!this.$v.$anyError) {
          this.form.token = this.$route.query.token;
          await this.ActionResetPassword(this.form);
          this.$notifications.addNotification({
            message: "Sua senha foi alterada com sucesso.",
            type: "success",
          });
          this.$router.push({ name: "login" });
        }
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao resetar senha.",
          type: "danger",
        });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
